// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root___SMOP","open":"Modal_open__UdKFv","modal":"Modal_modal__2Ity9","content":"Modal_content__bdVc3","close":"Modal_close__Cjpto"};